export const selo = require("./selo.png");
